import type { IAnimateConfig } from './../interface/graphic';

export const DefaultStateAnimateConfig: IAnimateConfig = {
  duration: 200,
  easing: 'cubicOut'
};

export const DefaultMorphingAnimateConfig: IAnimateConfig = {
  duration: 1000,
  easing: 'quadInOut'
};
